module.exports = __webpack_public_path__ + "img/หอยโข่ง.1a1cac6a.jpg";